import Request from '@hotmart/request'

Request.register(`${process.env.API_PRO}/api/v1`, {
  get: {
    'pro.integration.login': '/login/:page'
  }
})
